import { styled } from "@patientmpower/spiro";

export const DatepickerContainer = styled("div", {
  top: 128,
  zIndex: 3000,
  borderRadius: "16px",
  position: "absolute",
  boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.22)",
});
